module.exports = __webpack_public_path__ + "img/Lab_Book_Icon_Italic.dc5db661.svg";